<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<section class="add-custom-word">
  <div class="action-bar clear">
    <div class="left">
      <button
        type="button"
        class="xrx-btn btn-secondary btn medium glyph xgl-close mfd"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true" class="xgl-close"></span>
      </button>
    </div>
    <div class="right">
      <button
        class="xrx-btn btn-secondary btn medium glyph xgl-navigate_right"
        type="button"
        (click)="activeModal.close(matchCriteria.selectedValue)"
        [disabled]="customWordForm.invalid">
        <span class="btn-label text-medium button-forward-label" xdaTranslate
          >SDE_OK</span
        >
      </button>
    </div>
    <div class="middle">
      <span class="title text-x-large">{{ title }}</span>
    </div>
  </div>

  <div class="modal-body" iscroll tabindex="-1">
    <form #customWordForm="ngForm">
      <div class="form-group">
        <input
          #input
          class="form-control mfd"
          type="text"
          id="customString"
          name="customString"
          [(ngModel)]="matchCriteria.selectedValue.customString"
          (change)="
            matchCriteria.selectedValue.customString = $event.target.value
          "
          placeholder="{{ placeholder }}"
          required />
      </div>
    </form>

    <div class="mt-1">
      <ul class="action-list">
        <li>
          <xrx-popover
            class="w-100"
            [(param)]="matchCriteria"
            [(selectedValue)]="matchCriteria.selectedValue"
            (change)="value = $event.value"
            [showIcon]="false"
            [showLabel]="true"></xrx-popover>
        </li>
      </ul>
    </div>
  </div>
</section>
